import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonIcon,
  IonToolbar,
} from '@ionic/angular/standalone';
import { ThemeToggleComponent } from '@libs/core/lib/utils/theme/theme-toggle.component';
import { LanguageSwitcherComponent } from '@libs/mtjr/shared/i18n/language-switcher.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mav-landing',
  imports: [
    IonContent,
    IonButton,
    IonIcon,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    TranslatePipe,
    LanguageSwitcherComponent,
    IonHeader,
    IonToolbar,
    IonButtons,
    ThemeToggleComponent,
    IonIcon,
  ],
  template: `
    <ion-header [translucent]="true">
      <ion-toolbar>
        <ion-buttons slot="end" class="md:mx-4">
          <mtjr-language-switcher />
          <div (click)="themeSwitch.toggleTheme(); $event.stopPropagation()">
            <mtjr-theme-toggle #themeSwitch [disabled]="true" />
          </div>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <div class="flex flex-col items-center justify-center min-h-[80vh] text-center">
        <div class="mb-8">
          <img src="https://nbg1.your-objectstorage.com/mtjr/logo.svg" height="100" alt="" />
          <h1 class="text-4xl md:text-5xl font-bold text-primary mb-4 mt-6 ">
            {{ 'LANDING.WELCOME_TITLE' | translate }}
          </h1>
          <p class="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            {{ 'LANDING.WELCOME_SUBTITLE' | translate }}
          </p>
        </div>

        <ion-card class="max-w-lg w-full mx-auto">
          <ion-card-header>
            <ion-card-title>{{ 'LANDING.GET_STARTED' | translate }}</ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <p class="mb-6">
              {{ 'LANDING.WELCOME_DESCRIPTION' | translate }}
            </p>

            <div class="my-6 mx-4 text-left space-y-3">
              <div class="flex items-center gap-2">
                <ion-icon name="checkmark-circle" color="success"></ion-icon>
                <span class="text-base">{{ 'LANDING.FEATURE_MANAGE_PRODUCTS' | translate }}</span>
              </div>
              <div class="flex items-center gap-2">
                <ion-icon name="checkmark-circle" color="success"></ion-icon>
                <span class="text-base">{{ 'LANDING.FEATURE_TRACK_ORDERS' | translate }}</span>
              </div>
              <div class="flex items-center gap-2">
                <ion-icon name="checkmark-circle" color="success"></ion-icon>
                <span class="text-base">{{ 'LANDING.FEATURE_CUSTOMER_COMMUNICATION' | translate }}</span>
              </div>
            </div>

            <ion-button expand="block" size="large" class="mt-6 rounded-lg font-semibold" (click)="navigateToMain()">
              <ion-icon name="login" slot="start"></ion-icon>
              {{ 'LANDING.LOGIN_TO_DASHBOARD' | translate }}
            </ion-button>
          </ion-card-content>
        </ion-card>
      </div>
    </ion-content>
  `,
})
export class LandingPage {
  router = inject(Router);

  navigateToMain() {
    this.router.navigate(['/main'], { replaceUrl: true });
  }
}
